import { baseInstance } from "src/api";
import { MardAsReadPayload, PaginationData } from "src/types/api";

export const getUserNotifications = async (payload: PaginationData) => {
  try {
    return await baseInstance.get(
      `notify/notifications?page=${payload.page}&page_size=${payload.size}`
    );
  } catch (err: any) {
    return err;
  }
};

export const markAsReadNotification = async (payload: MardAsReadPayload) => {
  try {
    return await baseInstance.post(
      "notify/notifications/mark-as-read/",
      payload
    );
  } catch (err: any) {
    return err;
  }
};
